module.exports = __webpack_public_path__ + "static/media/Rectangle85.e3096f55.jpg";